import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import GoogleAdsSetupGuide from './guides/GoogleAdsSetupGuide';
import ConversionGuide from './ConversionGuide';
import CampaignStructureGuide from './guides/CampaignStructureGuide';
import BiddingGuide from './guides/BiddingGuide';
import LandingPageGuide from './guides/LandingPageGuide';
import NegativeKeywordsGuide from './guides/NegativeKeywordsGuide';
import RemarketingGuide from './guides/RemarketingGuide';
import KeywordMatchTypesGuide from './guides/KeywordMatchTypesGuide';
import MetaAdsSetupGuide from './guides/MetaAdsSetupGuide';
import MetaAudienceGuide from './guides/MetaAudienceGuide';
import MetaCreativeGuide from './guides/MetaCreativeGuide';
import { Container } from '@mantine/core';

const GUIDE_MAP = {
  'google-ads-setup': GoogleAdsSetupGuide,
  'conversions': ConversionGuide,
  'campaign-structure': CampaignStructureGuide,
  'bidding': BiddingGuide,
  'landing-pages': LandingPageGuide,
  'negative-keywords': NegativeKeywordsGuide,
  'remarketing': RemarketingGuide,
  'keyword-match-types': KeywordMatchTypesGuide,
  'meta-ads-setup': MetaAdsSetupGuide,
  'meta-audience': MetaAudienceGuide,
  'meta-creatives': MetaCreativeGuide,
};

export default function PublicGuide() {
  const { guideId } = useParams();
  const Component = GUIDE_MAP[guideId];

  if (!Component) return <Navigate to="/poradniki" />;

  return (
    <>
      <Navbar />
      <Container size="md" py={24}>
        <Component />
      </Container>
      <Footer />
    </>
  );
}
